import React from 'react';

const RELOADED_KEY = 'geo.chunkReload';
// A part that still fails this soon after a reload won't be helped by another: the network, not a deploy.
const RELOAD_AGAIN_AFTER_MS = 60_000;

const reloadedLately = () => {
  try {
    const at = Number(sessionStorage.getItem(RELOADED_KEY));
    return at > 0 && Date.now() - at < RELOAD_AGAIN_AFTER_MS;
  } catch {
    return false;
  }
};
const markReloaded = () => {
  try {
    sessionStorage.setItem(RELOADED_KEY, String(Date.now()));
    return true;
  } catch {
    return false;
  }
};

/**
 * A part of the app loaded when needed. A deploy removes the old parts, so a tab left open gets a
 * 404 for one: the page reloads to get the new ones, and if that doesn't help (no network) the
 * error goes on. Without somewhere to remember the reload it isn't tried, as it could go on for ever.
 */
export function loadOrReload<T>(load: () => Promise<T>, reload: () => void = () => window.location.reload()): Promise<T> {
  return load().catch((error) => {
    if (reloadedLately() || !markReloaded()) throw error;
    reload();
    // the page is going away: nothing is to be drawn meanwhile
    return new Promise<T>(() => undefined);
  });
}

export const lazyRoute = <T extends React.ComponentType<any>>(load: () => Promise<{ default: T }>) => React.lazy(() => loadOrReload(load));
